// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared chrome for the two in-canvas catalog drawers.
 *
 * The Node Catalog drawer and the Data Catalog drawer are the same screen over
 * different content, and they already share DrawerHeader, PackageSearchRow,
 * DrawerTabs and DrawerFooter. The panel around those was still written twice,
 * and the two copies had drifted: the same section label was #9E9E9E on one
 * side and #86878c on the other, the scroll body had different padding and a
 * different class name, the card list had different gaps, one empty state was
 * bare text and the other a dashed box, and only the node drawer honoured
 * prefers-reduced-motion.
 *
 * Both drawers import this file for the panel and keep only what is genuinely
 * per-kind (the dataset drawer's loading skeletons, each drawer's stacking
 * tier). The tier is passed in as --curio-drawer-z rather than hard-coded, so
 * the two keep their existing order in the scale.
 */

.EZ4VQOEQ7IF6vaFL2m87 {
    position: fixed;
    inset: 0;
    z-index: var(--curio-drawer-z, var(--curio-z-node-drawer));
    display: flex;
    justify-content: flex-end;
    /* Inert until presented, so a drawer mid-exit cannot swallow a canvas
       click. The node drawer used to be \`auto\` unconditionally. */
    pointer-events: none;
}

.sEBHjCHXx42xykVmrLnI {
    pointer-events: auto;
}

/* While a card dragged out of the panel is in the air, the root and the scrim
   let the drag through to the canvas beneath them; the panel keeps the
   pointer. useDrawerDragThrough sets the attribute, for every drawer. */
.EZ4VQOEQ7IF6vaFL2m87[data-dragging="true"] {
    pointer-events: none;
}

.EZ4VQOEQ7IF6vaFL2m87[data-dragging="true"] > .jKoUWIMsDd_fhEacdhkB {
    pointer-events: auto;
}

.XjhSH8mFkjEPxdxLFX1Q {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.12);
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0;
    transition: opacity 240ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* Panel slides in from the right; the scrim fades in alongside it. */
.jKoUWIMsDd_fhEacdhkB {
    position: relative;
    z-index: 1;
    width: min(520px, 100vw);
    height: 100%;
    background: var(--curio-page-bg);
    border-left: 1px solid var(--curio-border);
    box-shadow: var(--curio-shadow-modal);
    display: flex;
    flex-direction: column;
    font-family: var(--curio-font-family);
    color: var(--curio-text-primary);
    outline: none;
    transform: translate3d(100%, 0, 0);
    transition: transform 300ms cubic-bezier(0.32, 0.72, 0, 1);
    will-change: transform;
}

/* API Settings and Monitor: tables and tile grids need more room than a list
   of catalog cards. */
.qnMk0H5a1tpmK6HbUG8t {
    width: min(720px, 100vw);
}

.sEBHjCHXx42xykVmrLnI .XjhSH8mFkjEPxdxLFX1Q {
    opacity: 1;
}

.sEBHjCHXx42xykVmrLnI .jKoUWIMsDd_fhEacdhkB {
    transform: translate3d(0, 0, 0);
}

@media (prefers-reduced-motion: reduce) {
    .XjhSH8mFkjEPxdxLFX1Q,
    .jKoUWIMsDd_fhEacdhkB {
        transition-duration: 0.01ms;
    }
}

@media (max-width: 640px) {
    .jKoUWIMsDd_fhEacdhkB {
        width: 100vw;
    }
}

/* ── Scroll body ───────────────────────────────────────────────────────── */

.gLtM2WCKYo0VDAn4KSOw {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px;
    background: var(--curio-page-bg);
}

.ALadLRqCAfeCRO70sU7m {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
}

/* One empty state for both drawers. The node side used to render bare centred
   text where the dataset side drew a dashed box. */
.Cj3inxX44YqAQLPOmko6,
.MZswVMDZIR_1XkoH0A06 {
    margin-bottom: 12px;
    border: 1px dashed var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    color: var(--curio-text-meta);
    padding: 28px 12px;
    text-align: center;
    font-size: var(--curio-font-size-md);
}

.MZswVMDZIR_1XkoH0A06 {
    color: var(--curio-danger-text);
    background: var(--curio-danger-bg);
    border-color: var(--curio-danger-border);
}

/* ── Action error banner ───────────────────────────────────────────────── */

.IJay6N4jrp7sK358SALU {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 12px;
    margin: 0 0 16px;
    background: var(--curio-danger-bg);
    border: 1px solid var(--curio-danger-border);
    border-radius: var(--curio-radius-md);
    color: var(--curio-danger-text);
    font-size: var(--curio-font-size-md);
    font-family: var(--curio-font-family);
}

.reACSwlhl8yqMMW88WKN {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
}

.cneWGB_nQmE_eUVn2eJv {
    flex-shrink: 0;
    background: transparent;
    border: none;
    color: var(--curio-danger-text);
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
    margin: -2px -2px 0 0;
}

.cneWGB_nQmE_eUVn2eJv:hover {
    color: var(--curio-danger-strong);
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/CatalogDrawerShell.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;IACI,eAAe;IACf,QAAQ;IACR,0DAA0D;IAC1D,aAAa;IACb,yBAAyB;IACzB;kEAC8D;IAC9D,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;wEAEwE;AACxE;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,YAAY;IACZ,UAAU;IACV,eAAe;IACf,UAAU;IACV,sDAAsD;AAC1D;;AAEA,qEAAqE;AACrE;IACI,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,gCAAgC;IAChC,0CAA0C;IAC1C,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,kCAAkC;IAClC,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;sBACsB;AACtB;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;;QAEI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,6EAA6E;;AAE7E;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;mDACmD;AACnD;;IAEI,mBAAmB;IACnB,6CAA6C;IAC7C,qCAAqC;IACrC,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA,6EAA6E;;AAE7E;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,4CAA4C;IAC5C,qCAAqC;IACrC,+BAA+B;IAC/B,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":["/* Shared chrome for the two in-canvas catalog drawers.\n *\n * The Node Catalog drawer and the Data Catalog drawer are the same screen over\n * different content, and they already share DrawerHeader, PackageSearchRow,\n * DrawerTabs and DrawerFooter. The panel around those was still written twice,\n * and the two copies had drifted: the same section label was #9E9E9E on one\n * side and #86878c on the other, the scroll body had different padding and a\n * different class name, the card list had different gaps, one empty state was\n * bare text and the other a dashed box, and only the node drawer honoured\n * prefers-reduced-motion.\n *\n * Both drawers import this file for the panel and keep only what is genuinely\n * per-kind (the dataset drawer's loading skeletons, each drawer's stacking\n * tier). The tier is passed in as --curio-drawer-z rather than hard-coded, so\n * the two keep their existing order in the scale.\n */\n\n.overlayRoot {\n    position: fixed;\n    inset: 0;\n    z-index: var(--curio-drawer-z, var(--curio-z-node-drawer));\n    display: flex;\n    justify-content: flex-end;\n    /* Inert until presented, so a drawer mid-exit cannot swallow a canvas\n       click. The node drawer used to be `auto` unconditionally. */\n    pointer-events: none;\n}\n\n.overlayRootPresented {\n    pointer-events: auto;\n}\n\n/* While a card dragged out of the panel is in the air, the root and the scrim\n   let the drag through to the canvas beneath them; the panel keeps the\n   pointer. useDrawerDragThrough sets the attribute, for every drawer. */\n.overlayRoot[data-dragging=\"true\"] {\n    pointer-events: none;\n}\n\n.overlayRoot[data-dragging=\"true\"] > .drawer {\n    pointer-events: auto;\n}\n\n.scrim {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.12);\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    opacity: 0;\n    transition: opacity 240ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Panel slides in from the right; the scrim fades in alongside it. */\n.drawer {\n    position: relative;\n    z-index: 1;\n    width: min(520px, 100vw);\n    height: 100%;\n    background: var(--curio-page-bg);\n    border-left: 1px solid var(--curio-border);\n    box-shadow: var(--curio-shadow-modal);\n    display: flex;\n    flex-direction: column;\n    font-family: var(--curio-font-family);\n    color: var(--curio-text-primary);\n    outline: none;\n    transform: translate3d(100%, 0, 0);\n    transition: transform 300ms cubic-bezier(0.32, 0.72, 0, 1);\n    will-change: transform;\n}\n\n/* API Settings and Monitor: tables and tile grids need more room than a list\n   of catalog cards. */\n.drawerWide {\n    width: min(720px, 100vw);\n}\n\n.overlayRootPresented .scrim {\n    opacity: 1;\n}\n\n.overlayRootPresented .drawer {\n    transform: translate3d(0, 0, 0);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .scrim,\n    .drawer {\n        transition-duration: 0.01ms;\n    }\n}\n\n@media (max-width: 640px) {\n    .drawer {\n        width: 100vw;\n    }\n}\n\n/* ── Scroll body ───────────────────────────────────────────────────────── */\n\n.scrollBody {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 16px;\n    background: var(--curio-page-bg);\n}\n\n.cardList {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n/* One empty state for both drawers. The node side used to render bare centred\n   text where the dataset side drew a dashed box. */\n.empty,\n.error {\n    margin-bottom: 12px;\n    border: 1px dashed var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    color: var(--curio-text-meta);\n    padding: 28px 12px;\n    text-align: center;\n    font-size: var(--curio-font-size-md);\n}\n\n.error {\n    color: var(--curio-danger-text);\n    background: var(--curio-danger-bg);\n    border-color: var(--curio-danger-border);\n}\n\n/* ── Action error banner ───────────────────────────────────────────────── */\n\n.errorBanner {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 10px 12px;\n    margin: 0 0 16px;\n    background: var(--curio-danger-bg);\n    border: 1px solid var(--curio-danger-border);\n    border-radius: var(--curio-radius-md);\n    color: var(--curio-danger-text);\n    font-size: var(--curio-font-size-md);\n    font-family: var(--curio-font-family);\n}\n\n.errorBannerText {\n    flex: 1;\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n\n.errorBannerDismiss {\n    flex-shrink: 0;\n    background: transparent;\n    border: none;\n    color: var(--curio-danger-text);\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0 4px;\n    margin: -2px -2px 0 0;\n}\n\n.errorBannerDismiss:hover {\n    color: var(--curio-danger-strong);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayRoot": `EZ4VQOEQ7IF6vaFL2m87`,
	"overlayRootPresented": `sEBHjCHXx42xykVmrLnI`,
	"drawer": `jKoUWIMsDd_fhEacdhkB`,
	"scrim": `XjhSH8mFkjEPxdxLFX1Q`,
	"drawerWide": `qnMk0H5a1tpmK6HbUG8t`,
	"scrollBody": `gLtM2WCKYo0VDAn4KSOw`,
	"cardList": `ALadLRqCAfeCRO70sU7m`,
	"empty": `Cj3inxX44YqAQLPOmko6`,
	"error": `MZswVMDZIR_1XkoH0A06`,
	"errorBanner": `IJay6N4jrp7sK358SALU`,
	"errorBannerText": `reACSwlhl8yqMMW88WKN`,
	"errorBannerDismiss": `cneWGB_nQmE_eUVn2eJv`
};
export default ___CSS_LOADER_EXPORT___;
